import { collectGroupLeafItems } from '@/utils/presence-groups';

import { isEnrichmentOutsideCut, TEnrichmentTimeRange } from './is-enrichment-outside-cut';

/**
 * A presence card covers a whole group, so one offending leaf is enough to mark
 * it: the reviewer expands the group to find which thumbnail to delete.
 */
function isGroupOutsideCut<T extends TEnrichmentTimeRange>(
  group: { children?: T[] } | T,
  cutStart: Date | null,
  cutEnd: Date | null
): boolean {
  return collectGroupLeafItems<T>(group).some(item =>
    isEnrichmentOutsideCut(item, cutStart, cutEnd)
  );
}

export { isGroupOutsideCut };
